import ReactDOM, { Root } from "react-dom/client";
import React, { StrictMode } from "react";
import "./styles/_style.scss";
import App from "./App";

const root: Root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
